import { Pipe, PipeTransform } from '@angular/core';
import { StatisticsExtractor } from 'app/trello/utility/statistics-extractor';

@Pipe({
  name: 'uniqueCount',
  pure: true,
})
export class UniqueCountPipe implements PipeTransform {

  constructor(
    private readonly statisticsExtractor: StatisticsExtractor,
  ) {
  }

  transform(
    values:
      any[]
      |
      {
        [group: string]: any[],
      }
      |
      {
        [outerGroup: string]: {
          [innerGroup: string]: any[],
        },
      }
      |
      undefined,
  ): number | undefined {
    return this.statisticsExtractor.aggregateUniqueCount(values);
  }

}
